'use strict';

//Fetch module (defined in app.js)
angular.module('App.v1.Services')

    //******************** SERVICES *****************************************************************
    .factory('App.v1.Services.Odata.Snap', ['$resource', '$filter',
        function ($resource, $filter) {
            return $resource(
                '/odata/snap/:id',
                {},
                {
                    'query': { method: 'GET', isArray: true }
                }
            );
        }]);